// eslint-disable-next-line import/prefer-default-export
export const assetsOrder = [
  'ROSE',
  'YUZU',
  'ONE',
  'WONE',
  'FTM',
  'WFTM',
  'MATIC',
  'WMATIC',
  'BUSD',
  'DAI',
  'UNIDAI',
  'GUSD',
  'GHST',
  'SUSD',
  'TUSD',
  'USDC',
  'UNIUSDC',
  'USDP',
  'USDT',
  'UNIUSDT',
  'EURS',
  'BAL',
  'ETH',
  'WETH',
  'SETH',
  'SUSHI',
  'LINK',
  'MKR',
  'RAI',
  'UNI',
  'WBTC',
  'XSUSHI',
  'YFI',
  'FEI',
  'FRAX',
  'SSAP',
  'AAVE',
  'AMPL',
  'BAT',
  'CRV',
  'DPI',
  'ENJ',
  'KNC',
  'LEND',
  'MANA',
  'PAX',
  'REN',
  'RENFIL',
  'REP',
  'REI',
  'SNX',
  'ZRX',

  'UNIDAIUSDC',
  'UNIUSDCDAI',
  'UNIWBTCUSDC',
  'UNIDAIETH',
  'UNIDAIWETH',
  'UNIUSDCETH',
  'UNIUSDCWETH',
  'UNIAAVEWETH',
  'UNIBATWETH',
  'UNICRVWETH',
  'UNISETHETH',
  'UNILENDETH',
  'UNILINKETH',
  'UNILINKWETH',
  'UNIMKRETH',
  'UNIMKRWETH',
  'UNIRENWETH',
  'UNISNXWETH',
  'UNIUNIWETH',
  'UNIWBTCWETH',
  'UNIYFIWETH',

  'GUNIDAIUSDC',
  'GUNIUSDCUSDT',

  'BPTBALWETH',
  'BPTDPIWBTCWETH',
  'BPTLINKWETH',
  'BPTMKRWETH',
  'BPTSNXWETH',
  'BPTUSDCWETH',
  'BPTWBTCWETH',
  'BPTWETHDAI',
  'BPTWETHUSDT',
  'BPTYFIWETH',
];
